import React from 'react';
import { Container } from '@hover/blueprint';
import TrustedContent from './TrustedContent';
import { TrustedByNamesSlide } from '../../common';

const TrustedByNameMobile: React.FC = () => (
  <Container
    pt="72px"
    pb={1000}
    px={0}
    d={{ base: 'block', tablet: 'none' }}
    maxW="100%"
    centerContent
  >
    <TrustedContent />
    <TrustedByNamesSlide />
  </Container>
);

export default TrustedByNameMobile;
